// extracted by mini-css-extract-plugin
export var logo = "_bq-2";
export var logoWrapper = "_bq-1";
export var strip = "_bq-0";